module.exports = __webpack_public_path__ + "img/arrow.a0353f8f.svg";